// Public key access token using MapTiler: https://cloud.maptiler.com/maps/pastel/maplibre-gl-js
export const MAPTILER_API_TOKEN = 'U6h4Yyk9E2vA6TEG8BOM' // pragma: allowlist secret
